import React, { useState, useEffect } from "react";
import { handleLogin, getDhanProfile } from "../../services/apicall.tsx";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useUserContext, Statescontex } from "../../context";
import { Input, Button, Form, Typography } from "antd";
import { colors } from "../../devdata/constants/themes";
import { Anilogsign } from "../../components/index.js";
import expandedLogo from "../../devdata/icons/marketpulse.svg";
import GoogleBulbul from "../../components/oauth/google_login.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import DhanLogin from "../../components/oauth/dhan_login.tsx";
const { Text } = Typography;

const UserLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [G, setG] = useState(false);
  const [isKeyboardActive, setIsKeyboardActive] = useState(false);
  const { setErrorshow, setErrorMessage } = Statescontex();
  const { userToken, setuserToken, setlogin, isloggedin, userdetails, setIsDhanLogged, setdhanToken } =
    useUserContext();
  const [Redirect, setRedirect] = useState(false)
  useEffect(() => {
    if (process.env.REACT_APP_NODE_ENV !== "prod") {
      setUsername("akashpatelyo3@gmail.com");
      setPassword("Akashpatel@1");
    }
  }, []);
  useEffect(() => {
    if (G) {
      handleSubmit();
    }
  }, [G]);
  useEffect(() => {
    const tokenId = searchParams.get("tokenId");
    const from = sessionStorage.getItem("from")
    if (tokenId && from) {
      // sessionStorage.removeItem("from")
      getDhanProfile(tokenId, setPassword, setPassword, setUsername, setG, setErrorshow, setErrorMessage, setLoading, true)
    }
  }, [])
  const navi = useNavigate()

  // Add keyboard event listeners
  useEffect(() => {
    const handleKeyboardDidShow = () => {
      setIsKeyboardActive(true);
    };

    const handleKeyboardDidHide = () => {
      setIsKeyboardActive(false);
    };

    // For mobile web, we'll use focus/blur events on inputs as a proxy for keyboard visibility
    const inputElements = document.querySelectorAll("input");

    inputElements.forEach((input) => {
      input.addEventListener("focus", handleKeyboardDidShow);
      input.addEventListener("blur", handleKeyboardDidHide);
    });

    return () => {
      inputElements.forEach((input) => {
        input.removeEventListener("focus", handleKeyboardDidShow);
        input.removeEventListener("blur", handleKeyboardDidHide);
      });
    };
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    try {
      handleLogin(
        username,
        password,
        setLoading,
        setuserToken,
        setlogin,
        setErrorMessage,
        setErrorshow,
        G,
        setRedirect
      );
    } catch (e) {
      console.error("External error", e);
      setlogin(false);
      setUsername("Error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isloggedin === true && userToken !== "" && userToken !== "loggedout") {
      if (userdetails && userdetails.isverified && userdetails.role === "user") {
        navi("/Dashboard", { replace: true })
      }
      else if (userdetails && !userdetails.isverified && userdetails.role === "user") {
        navi("/Verify", { replace: true })
      }
    }
  }, [userdetails, isloggedin]);
  useEffect(() => {
    if (isloggedin === true && userToken !== "" && userToken !== "loggedout") {
      if (userdetails && userdetails.isverified && userdetails.role === "user") {
        navi("/Dashboard", { replace: true })
      }
      else if (userdetails && !userdetails.isverified && userdetails.role === "user") {
        navi("/Verify", { replace: true })
      }
    }
  }, []);
  function dum() {
    console.log("OK");

  }
  useEffect(() => {
    if (Redirect) {
      setTimeout(() => {

        navi("/signup")
      }, 1000);
    }
  }, [Redirect])

  return (
    <div className="flex h-screen sm:h-auto flex-col sm:flex-row">
      {/* Full height screen on desktop, auto on mobile, flex direction changes on small screens */}
      <div className="sm:w-1/2 relative h-1/2 sm:h-screen bg-gradient-to-br from-[#005C32] to-[#11CD77] hidden sm:block">
        <img
          alt="bars"
          src={require("../../devdata/assets/bars.png")}
          className="h-full"
        />
        <div
          style={{ position: "absolute", top: "30%" }}
          className="hidden lg:block xl:left-1/2 xl:-translate-x-1/2 lg:left-1/2 lg:-translate-x-1/2"
        >
          <Anilogsign />
        </div>
        {/* Green left/top section, hidden on mobile, visible on larger screens */}
      </div>
      <div className="sm:w-1/2 min-h-screen bg-darkMode-background flex flex-col justify-center items-center p-8 sm:p-8">
        {/* Dark right/bottom section, min-h-screen for mobile, padding adjusted */}
        {/* Logo at top, hidden when keyboard is active */}
        {!isKeyboardActive && (
          <div className="absolute top-8">
            <Link to={"/"}>
              <img src={expandedLogo} alt="Expanded Logo" className="w-64" />
            </Link>
          </div>
        )}
        <div className="w-full sm:max-w-md flex flex-col justify-center items-center">
          {/* Container for form and headings, max width on small screens and up */}
          <h1 className="text-2xl sm:text-3xl font-semibold mb-2 text-darkMode-text text-center">
            {/* Adjusted heading text size for small screens */}
            Log in to your account
          </h1>
          {/* White heading */}
          <p className="text-darkMode-subText mb-4 sm:mb-6 text-sm text-center">
            {/* Adjusted paragraph margin bottom for small screens */}
            Welcome, Select method to log-in
          </p>
          {/* Grey sub-heading */}
          <div className="text-darkMode-text w-full sm:w-2/3">
            {/* White form container, full width on small screens, 2/3 on larger */}
            <Form layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>
                    Email/Phone number
                  </label>
                }
                name="emailOrPhone"
              >
                <Input
                  type="text"
                  // placeholder="Enter your email or phone number"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={{
                    borderRadius: "0.5rem",
                    padding: "0.75rem",
                    color: "black",
                  }}
                  className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                />
              </Form.Item>

              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>
                    Password
                  </label>
                }
                name="password"
              >
                {/* Label color black */}
                <Input.Password
                  // placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    borderRadius: "0.5rem",
                    padding: "0.75rem",
                    color: "black",
                  }} // Input style
                  iconRender={visible => (
                    visible ? <FontAwesomeIcon icon={faEyeSlash} style={{ width: 20, height: 20 }} color="black" /> : <FontAwesomeIcon icon={faEye} style={{ width: 20, height: 20 }} color="black" />
                  )}
                  className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                />
              </Form.Item>
              <div className="flex justify-end items-center mb-4 sm:mb-6">
                {/* Forgot password right aligned, margin bottom adjusted for small screens */}
                <Text className="text-darkMode-subText">
                  <Link to="/forgotpass" className="">
                    {/* Green forgot password link */}
                    <span className="text-darkMode-green text-sm sm:text-base underline">
                      {/* Adjusted forgot password text size for small screens */}
                      Forgot Password
                    </span>
                  </Link>
                </Text>
              </div>
              <Form.Item>
                <button
                  htmltype="submit"
                  className="w-full rounded-xl py-2 sm:py-3"
                  style={{
                    backgroundColor: colors.darkMode.green,
                    borderColor: "#50CD89",
                  }}
                >
                  <span className="text-green-900 sm:text-xl font-semibold">
                    {loading === true ? "Logging in..." : "Log-in"}
                  </span>
                </button>
              </Form.Item>
              {/* Divider */}
              <div className="flex items-center my-4">
                <hr className="flex-grow border-t border-gray-300" />
                <span className="mx-2 text-darkMode-subText text-sm">OR</span>
                <hr className="flex-grow border-t border-gray-300" />
              </div>
              {/* Google Login */}
              <Form.Item className="mb-0">
                <GoogleBulbul
                  setPassword={setPassword}
                  setusername={setUsername}
                  setG={setG}
                  setName={dum}
                  fromLogin={true}
                  setconfirmpass={dum}
                  className="w-full"
                />
              </Form.Item>

              <Form.Item>
                <DhanLogin from={"Login"} className="w-full" />
              </Form.Item>
            </Form>
          </div>
          <div className="text-center mt-3">
            {/* Don't have account section */}
            <Text className="text-darkMode-text text-xl">
              Don't Have An Account?{" "}
              <Link to="/signup" className="">
                {/* Green register link */}
                <span className="text-darkMode-green text-xl underline">
                  {/* Adjusted register text size for small screens */}
                  Register
                </span>
              </Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
